<template>

	<div v-if="auth_store.status === 'error'" class="flex min-h-screen items-center justify-center px-6" style="background: var(--brand-splash)">
		<div class="w-full max-w-sm rounded-2xl border border-[#303030] bg-[#171717] p-6 text-center text-white">
			<p class="text-lg font-semibold">{{ locale === 'ru' ? 'Не удалось загрузить данные' : 'Could not load data' }}</p>
			<p class="mt-2 text-sm text-[#a4a4a4]">{{ locale === 'ru' ? 'Проверьте соединение и попробуйте ещё раз.' : 'Check your connection and try again.' }}</p>
			<p class="mt-3 text-xs text-[#a4a4a4]">{{ locale === 'ru' ? 'Код диагностики:' : 'Diagnostic code:' }} {{ auth_store.auth_error_code || 'UNKNOWN' }}</p>
			<button class="stark-primary-button" type="button" @click="startSession">{{ locale === 'ru' ? 'Повторить' : 'Retry' }}</button>
		</div>
	</div>

	<!-- Прелоадер -->
	<div
		class="items-center justify-center flex h-screen w-screen px-10"
		style="background: var(--brand-splash)"
		v-else-if="need_show_preloader"
	>
		<!-- Вордмарк вставляем как есть, без трансформаций и фильтров (см. BRAND.md → Misuse) -->
		<NuxtImg src="/stark_logo.svg" alt="STARK" class="w-full max-w-[260px] h-auto" />
	</div>

	<!-- Основной контент -->
	<!-- class="h-screen overflow-auto" -->
	<!-- 'mt-14': !is_tg, -->
	<!-- class="min-h-screen" -->
	<!-- class="overflow-hidden absolute inset-0" -->
	<div 
		v-else
		:class="{
			'mt-14': !is_tg && !is_stark_card_flow,
			'pb-20': !is_tg && is_tg_bottom_menu_visible && !is_stark_card_flow,
		}"
	>

		<VirtualTgTopMenu v-if="!is_tg && !is_stark_card_flow"/>

		<!-- <div 
			class="sticky w-full z-50 left-0 h-14 inset-0"
			:class="{
				'top-0': is_tg,
				
			}"
		>
			<div class="flex justify-between w-full py-3 px-6 w-full bg-white\60 backdrop-blur-lg">
				<div class="flex items-center flex-1">
					<UIcon
						name="i-solar-list-linear"
						class="w-8 h-8 text-gray-800 cursor-pointer"
					/>
				</div>
				<div class="flex items-center text-xl font-semibold flex-2">Карта</div>
				<div class="flex items-center justify-end flex-1">
					<UIcon
						v-if="true"
						class="w-6 h-6 text-gray-800 cursor-pointer"
						name="i-tabler-eye-closed"
					/>
					<UIcon
						v-else
						class="w-8 h-8 text-gray-800 cursor-pointer"
						name="i-tabler-eye"
					/>
				</div>
			</div>

		</div> -->

		<slot />

		<VirtualTgBottomMenu v-if="!is_tg && !is_stark_card_flow"/>

	</div>

	<TopMenuModal/>
	
	
</template>

<script setup lang="ts">

import VirtualTgTopMenu from '~/components/VirtualTgTopMenu.vue';
import VirtualTgBottomMenu from '~/components/VirtualTgBottomMenu.vue';
import { routeRoles } from '~/config/route-roles';

// import tailwind from '/assets/tailwind.css'

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/card_stark_bg_plain.svg',
    },
  ],
})

const config = useRuntimeConfig()

const auth_store = useAuthStore();

const main_store = useMainStore();
const { is_tg_back_button_visible, is_tg_main_button_visible, is_tg_bottom_menu_visible, is_tg } = storeToRefs(main_store);

const { locales, setLocale, locale, t } = useI18n()

const is_tg_init = ref(false)

const is_redirects_processed = ref(false)

const need_show_preloader = computed(() => {
	if (!is_tg_init.value) {
		return true
	}
	if (auth_store.status != 'success') {
		return true
	}
	if (!is_redirects_processed.value) {
		return true
	}
	return false
})


const intervals: Ref<NodeJS.Timeout[]> = ref([])

const initTelegram = () => {
	if (window.Telegram && window.Telegram.WebApp && typeof window.Telegram.WebApp.ready === 'function') {

		// console.log(window.location)
		// console.log(window.location.hash)

		// const hash = window.location.hash.replace('#', '');
		// const decodedHash = decodeURIComponent(hash);

		// console.warn('decodedHash:', decodedHash);

		// const params = new URLSearchParams(decodedHash);

		// console.warn('params:', params);

		// const tgWebAppData = params.get('tgWebAppData');

		// console.warn('tgWebAppData from hash:', tgWebAppData);

		// console.log('Hash:', window.location.hash);

		// console.warn('config.public.init_data_hash_dev',config.public.init_data_hash_dev);
		
		if (import.meta.dev && config.public.init_data_hash_dev) {
			auth_store.store_tg_init_data_hash(config.public.init_data_hash_dev)
		}
		// В production сохраняем путь запуска, захваченный auth.global для /tma_login.

		window.Telegram.WebApp.ready();
		window.Telegram.WebApp.expand();

		// STARK Black (brandbook, стр. 10)
		window.Telegram.WebApp.setHeaderColor('#101010');

		window.Telegram.WebApp.setBottomBarColor('#070707');
		window.Telegram.WebApp.setBackgroundColor('#070707');
		window.Telegram.WebApp.enableClosingConfirmation();
		window.Telegram.WebApp.disableVerticalSwipes();
		is_tg_init.value = true
	} else if (import.meta.dev) {
		if (config.public.init_data_hash_dev) {
			auth_store.store_tg_init_data_hash(config.public.init_data_hash_dev)
		}
		is_tg_init.value = true
	} else {
		// Повторяем попытку через короткий интервал
		setTimeout(initTelegram, 100);
	}
};

async function locale_init() {
	if (auth_store?.user?.language_code) {
		await setLocale(auth_store?.user?.language_code)
		useDayjs().locale(auth_store?.user?.language_code)
	}
}

const route = useRoute()
const router = useRouter()
const is_stark_card_flow = computed(() => route.path === '/' || route.path.startsWith('/guide') || route.path.startsWith('/card-blue'))

// async function ensure_redirects_green_c(){
// 	if (auth_store?.green_c_state?.status == 'paid' && route.name != 'card-green-kyc') {
// 		await navigateTo({
// 			name: 'card-green-kyc',
// 		})
// 	}
// 	if (auth_store?.green_c_state?.status == 'issuing' && route.name != 'card-green-issue-process') {
// 		await navigateTo({
// 			name: 'card-green-issue-process'
// 		})
// 	}
// 	if (auth_store?.green_c_state?.status == 'active' && route.name != 'card-green') {
// 		await navigateTo({
// 			name: 'card-green'
// 		})
// 	}
// 	is_redirects_processed.value = true
// }

async function ensure_redirects_blue_c(){
	if (router.currentRoute.value.path.startsWith('/guide')) {
		is_redirects_processed.value = true
		return
	}

	if (auth_store?.blue_c_state?.status == 'paid' && route.name != 'card-blue-kyc') {
		await navigateTo({
			name: 'card-blue-kyc',
		})
	}
	if (auth_store?.blue_c_state?.status == 'inactive' && route.name != 'card-blue-kyc') {
		await navigateTo({
			name: 'card-blue-kyc',
		})
	}
	if (auth_store?.blue_c_state?.status == 'issuing' && route.name != 'card-blue-issue-process') {
		await navigateTo({
			name: 'card-blue-issue-process'
		})
	}
	if (auth_store?.blue_c_state?.status == 'active' && route.name != 'card-blue') {
		await navigateTo({
			name: 'card-blue'
		})
	}

	is_redirects_processed.value = true
}

async function startSession() {
	if (auth_store.status === 'loading') return
	auth_store.status = 'loading'
	is_redirects_processed.value = false
	try {
		await auth_store.ensure_session()
		if (auth_store.status !== 'success') throw new Error('Session is unavailable')
		await locale_init()
		await ensure_redirects_blue_c()
	} catch (error) {
		console.error('Session initialization failed:', error)
		auth_store.status = 'error'
	}
}

watch(is_tg_init, (ready) => {
	if (ready) startSession()
})

onMounted(async () => {
	initTelegram();

	intervals.value.push(
		setInterval(async () => {
			if (need_show_preloader.value) {return}
			await auth_store.get_user()
		}, 10 * 1000)
	)

})

onUnmounted(() => {
	intervals.value.forEach(clearInterval)
})

</script>
